import { apolloClient as client } from 'src/graphql';
import { SuggestedChangesDocument } from 'src/graphql/actions/suggestChanges/suggestedChanges.query';

export const refetchSuggestedChanges = () => {
  client.cache.evict({ fieldName: 'suggestedChanges' });
  client.cache.gc();
  client.refetchQueries({
    include: [SuggestedChangesDocument],
  });
};
